import React from "react";
import { FormControl, InputAdornment, TextField } from "@mui/material";
import { styInput, textareaSty } from "./styles-input";
import { InputSizeIconPropType, TextareaIconPropType } from "../../interface/inputs";

const InputCustom = ({
  placeholder,
  value,
  styles,
  type,
  onchange,
  size,
}: InputSizeIconPropType) => {
  // const classes = useStyles();

  return (
    
    <TextField
      placeholder={placeholder}
      type={type}
      // className={classes.customInput}
      value={value}
      onChange={onchange}
      size={size}
      sx={{
        "& .MuiInputBase-root": {
          backgroundColor: "#f5f7f9", // Change input background
          borderRadius: "8px", // Rounded corners
        },
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "none", // Outline color
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: "#none", // Outline color on hover
        },
        "& .MuiInputLabel-root": {
          color: "#4CAF50", // Label color
        },
        ...styles,
      }}
    />
  );
};

const InputTextarea = ({
  placeholder,
  value,
  styles,
  type,
  onchange,
  row,
}: TextareaIconPropType) => {
  // const classes = useStyles();

  return (
    
    <TextField
      placeholder={placeholder}
      type={type}
      // className={classes.customInput}
      value={value}
      onChange={onchange}
      rows={row}
      multiline
      sx={{
        "& .MuiInputBase-root": {
          backgroundColor: "#f5f7f9", // Change input background
          borderRadius: "8px", // Rounded corners
        },
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "none", // Outline color
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: "#none", // Outline color on hover
        },
        "& .MuiInputLabel-root": {
          color: "#4CAF50", // Label color
        },
        ...styles,
      }}
    />
  );
};

export { InputCustom,InputTextarea  };
